/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Export_BusyInputs */

const en_us2_history_transfer_export_busy = /** @type {(inputs: History_Transfer_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing…`)
};

const pt_br2_history_transfer_export_busy = /** @type {(inputs: History_Transfer_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando…`)
};

const es_419_history_transfer_export_busy = /** @type {(inputs: History_Transfer_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando…`)
};

const pt_pt2_history_transfer_export_busy = /** @type {(inputs: History_Transfer_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A preparar…`)
};

const fr_fr2_history_transfer_export_busy = /** @type {(inputs: History_Transfer_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation…`)
};

const de_de2_history_transfer_export_busy = /** @type {(inputs: History_Transfer_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird vorbereitet…`)
};

const it_it2_history_transfer_export_busy = /** @type {(inputs: History_Transfer_Export_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione…`)
};

/**
* | output |
* | --- |
* | "Preparing…" |
*
* @param {History_Transfer_Export_BusyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_export_busy = /** @type {((inputs?: History_Transfer_Export_BusyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Export_BusyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_export_busy(inputs)
	if (locale === "es-419") return es_419_history_transfer_export_busy(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_export_busy(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_export_busy(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_export_busy(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_export_busy(inputs)
	return en_us2_history_transfer_export_busy(inputs)
});
export { history_transfer_export_busy as "history-transfer.export_busy" }